export default "__VITE_ASSET__jOQ05yw2__"